// InventarioRoutesXL - Sprint 44 Fase 3 Vista 5.
// Reemplaza modules/inventario/routes.jsx. Rutas preservadas:
// /inventario (index), /inventario/:id/kardex.
import { Routes, Route } from 'react-router-dom';
import InventarioListXL from './InventarioListXL';
import KardexProductoXL from './KardexProductoXL';

export default function InventarioRoutesXL() {
  return (
    <Routes>
      <Route index element={<InventarioListXL />} />
      <Route path=":id/kardex" element={<KardexProductoXL />} />
    </Routes>
  );
}
